import { api } from './client';
import { endpoints } from './endpoints';

/** The signed-in user's own feed. Every role uses the same endpoints. */
export function listNotifications(params) {
  return api.getPaginated(endpoints.notifications.root, { params });
}

export function getUnreadCount() {
  return api.get(endpoints.notifications.unreadCount);
}

export function markRead(id) {
  return api.post(endpoints.notifications.read(id));
}

export function markAllRead() {
  return api.post(endpoints.notifications.readAll);
}

export function deleteNotification(id) {
  return api.delete(endpoints.notifications.byId(id));
}

export function getPreferences() {
  return api.get(endpoints.notifications.preferences);
}

export function updatePreferences(input) {
  return api.patch(endpoints.notifications.preferences, input);
}
